import React from "react";
import { Col, Row } from "react-bootstrap";
import HeaderSection from "./HeaderSection";
import IconHeading from "../HeaderDesk/RevampHeader/IconHeading";
import IpoCardBlock from "./IpoCardBlock";
import { HeaderEnum } from "../HeaderDesk/RevampHeader/constant";
import Viewall from "@frameworks/web/components/generic/viewAll";
const IpoMob = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0" },
            React.createElement(Col, { lg: 12, className: "mgt-40 px-0" },
                React.createElement(HeaderSection, { title: "IPO" })),
            React.createElement(Col, { lg: 12, className: "px-0 mgt-15" },
                React.createElement("div", { className: "d-flex gap-50 ps-4" },
                    React.createElement(IconHeading, { tilte: "IPO", icon: React.createElement("i", { className: "edel-icon-ncd" },
                            React.createElement("span", { className: "path1" }),
                            React.createElement("span", { className: "path2" }),
                            React.createElement("span", { className: "path3" }),
                            React.createElement("span", { className: "path4" }),
                            React.createElement("span", { className: "path5" }),
                            React.createElement("span", { className: "path6" }),
                            React.createElement("span", { className: "path7" }),
                            React.createElement("span", { className: "path8" })), parentClassName: "icon-mob", linkContent: HeaderEnum.IPO }),
                    React.createElement(IconHeading, { tilte: "NCD IPO", icon: React.createElement("i", { className: "edel-icon-ncd-ipo" },
                            React.createElement("span", { className: "path1" }),
                            React.createElement("span", { className: "path2" })), parentClassName: "icon-mob", linkContent: HeaderEnum.NCD }),
                    React.createElement(IconHeading, { tilte: "NFO", icon: React.createElement("i", { className: "edel-icon-nfo" },
                            React.createElement("span", { className: "path1" }),
                            React.createElement("span", { className: "path2" }),
                            React.createElement("span", { className: "path3" }),
                            React.createElement("span", { className: "path4" }),
                            React.createElement("span", { className: "path5" }),
                            React.createElement("span", { className: "path6" }),
                            React.createElement("span", { className: "path7" }),
                            React.createElement("span", { className: "path8" })), parentClassName: "icon-mob", linkContent: HeaderEnum.NFO }))),
            React.createElement(Col, { lg: 12, className: "text-right DMSan_14_500 mb-4" },
                "View All",
                React.createElement(Viewall, { size: "30" })),
            React.createElement(Col, { lg: 12, className: "mobile-offering-data px-0" },
                React.createElement(IpoCardBlock, null)))));
};
export default IpoMob;
